import { useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    path: 'subscriber',
    context: 'selected',
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onClick() {
    // reset the intended individual deletion
    change({})

    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
